module.exports = __webpack_public_path__ + "static/media/activities.9dc48323.png";